// Transfer entry points (Gumroad, future storefronts). Add fields as the flow grows.

export const TRANSFER_SOURCE_KIND = {
  GUMROAD: 'gumroad',
};

export const transferSources = [
  {
    id: 'gumroad_revolt_unreal_engine_plugin',
    displayName: 'Revolt Unreal Engine plugin (Gumroad)',
    detailTitle: 'Transferring: Revolt Unreal Engine Plugin from Gumroad',
    kind: TRANSFER_SOURCE_KIND.GUMROAD,
    listIconClass: 'fa-solid fa-store',
  },
];

export function getTransferSourceById(id) {
  return transferSources.find((s) => s.id === id) ?? null;
}
